import { combineReducers } from 'redux'
import userData from './user'
export default combineReducers({
    userData
})